<template>
    <div>
        <el-card>
            <div slot="header">
                <span>标题</span>
            </div>

            <div class="row center-row">
                <div style="">

                    <alert
                    :show.sync="show" @selected='getSelect'
                    :model="'Admin'"
                    :condition="[{'field':'username','condition':'=','placeholder':'用户名'},{'field':'email','condition':'like','placeholder':'邮箱'},{'field':'role.title','condition':'like','placeholder':'角色'}]"
                    :label="[{'label':'用户名','key':'username'},{'label':'邮箱','key':'email'},{'label':'上次登录时间','key':'last_login_time'},{'label':'角色','key':'role.title'}]"
                    >
                    </alert>

                    <el-button @click='show=!show'>显示</el-button>

                    <el-button @click='show2()'>显示2</el-button>
                    <el-button @click='show3()'>显示3</el-button>
                </div>
            </div>


        </el-card>
    </div>
</template>

<script>

    import Alert from '../common/Alert.vue'

    export default {
        name: "Test",
        data() {
            return {
              show:false
            }
        },
        methods: {

          getSelect(row){

            console.log(row);

          },
          show2(){

            this.$showAlert(
            'Admin',
            [{'field':'username','condition':'=','placeholder':'用户名'},{'field':'email','condition':'like','placeholder':'邮箱'},{'field':'role.title','condition':'like','placeholder':'角色'},{'field':'id','condition':'>','placeholder':'ID',show:false}],
            [{'label':'ID','key':'id'},{'label':'用户名','key':'username'},{'label':'邮箱','key':'email'},{'label':'上次登录时间','key':'last_login_time'},{'label':'角色','key':'role.title'}]
            )
          },
          show3(){

            this.$showAlert('Test',[],[{label:"名称",key:"name"},{label:"年龄",key:'age'}],(re)=>{

              console.log(re);

            })


          }


        },
        created(){

        },
        computed:{

        },
        components:{
          Alert
        }

    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/test/Test.vue